module.exports = __webpack_public_path__ + "img/scooter-1x.837f9a70.png";